import { render, staticRenderFns } from "./DocumentInsurance.vue?vue&type=template&id=7b23fa1c"
import script from "./DocumentInsurance.vue?vue&type=script&lang=js"
export * from "./DocumentInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports